export const getColumns = (viewType, centrality,isWidth=true) => {

  switch (viewType) {
    case "Tumorigenesis":
      return [
        {
          name: <span className="table-header">Gene Name</span>,
          selector: (row) => row.geneName,
          ...(isWidth && { width: "120px" }),

        },
        {
          name: <span className="table-header">p-value (t-test)</span>,
          selector: (row) => row.P_Value,
          ...(isWidth && { width: "150px" }),

        },
        {
          name: <span className="table-header">Log2 Fold Change (Tumor vs. Normal)</span>,
          selector: (row) => row.logFC_TvN,
          ...(isWidth && { width: "200px" }),

        },
        {
          name: <span className="table-header">FDR</span>,
          selector: (row) => row.FDR,
        },
        {
          name: <span className="table-header">Paired</span>,
          selector: (row) => row.paired,
        },
        {
          name: <span className="table-header">Data Level</span>,
          selector: (row) => row.dataLevel,
        },
        {
          name: <span className="table-header">Category</span>,
          selector: (row) => row.category,
        },
        {
          name: <span className="table-header">Cancer Type</span>,
          selector: (row) => row.cancer_type,
          ...(isWidth && { width: "130px" }),
        },
        {
          name: <span className="table-header">Histological Subtype</span>,
          selector: (row) => row.histological_subtype,
           ...(isWidth && { width: "180px" }),
        },
        
      ];

    case "Survival":
      return [
        {
          name: <span className="table-header">Gene Name</span>,
          selector: (row) => row.geneName,
          sortable: true,
            ...(isWidth && {  width:"135px"}),
        },
        {
          name: <span className="table-header">p-value (log-rank test)</span>,
          selector: (row) => row.logrank_p,
          sortable: true,
             ...(isWidth && { width:"215px"})
        },
        {
          name: <span className="table-header">HR</span>,
          selector: (row) => row.HR,
          sortable: true,
        },
        {
          name: <span className="table-header">Confidence Interval (95%)</span>,
          selector: (row) => row.CI_95,
          sortable: true,
             ...(isWidth && {  width:"240px"})
        },
        {
          name: <span className="table-header">Data Level</span>,
          selector: (row) => row.dataLevel,
          sortable: true,
        },
        {
          name: <span className="table-header">Category</span>,
          selector: (row) => row.category,
          sortable: true,
        },
        {
          name: <span className="table-header">Cancer Type</span>,
          selector: (row) => row.cancer_type,
          sortable: true,
           ...(isWidth && {   width:"140px"})
        },
        {
          name: <span className="table-header">Histological Subtype</span>,
          selector: (row) => row.histological_subtype,
          sortable: true,
             ...(isWidth && { width:"200px"})
        },
        // {
        //   name: <span className="table-header">Plot File</span>,
        //   selector: (row) => row.plot_file,
        //   sortable: true,
        // },
        {
          name: <span className="table-header">Plot Cutoff</span>,
          selector: (row) => row.plot_cutoff,
          sortable: true,
              ...(isWidth && {  width:"125px"})
        },
      ];
    case "Proliferation":
      return [
        {
          name: <span className="table-header">Gene Name</span>,
          selector: (row) => row.geneName,
             ...(isWidth && {  width:"120px"})
        },
        {
          name: (
            <span className="table-header">
              # Available Cell Lines (CRISPR)
            </span>
          ),
          selector: (row) => row.number_of_avail_cell_lines_CRISPR,
             ...(isWidth && {  width:"200px"})
        },
        {
          name: (
            <span className="table-header">
              # Significant Cell Lines (CRISPR)
            </span>
          ),
          selector: (row) => row.number_of_sig_cell_lines_CRISPR,
             ...(isWidth && {  width:"200px"})
        },
        {
          name: <span className="table-header">Significant % (CRISPR)</span>,
          selector: (row) => row.sig_percent_CRISPR,
              ...(isWidth && { width:"200px"})
        },
        {
          name: (
            <span className="table-header"># Available Cell Lines (RNAi)</span>
          ),
          selector: (row) => row.number_of_avail_cell_lines_RNAi,
             ...(isWidth && {  width:"200px"})
        },
        {
          name: (
            <span className="table-header">
              # Significant Cell Lines (RNAi)
            </span>
          ),
          selector: (row) => row.number_of_sig_cell_lines_RNAi,
            ...(isWidth && {  width:"200px"})
        },
        {
          name: <span className="table-header">Significant % (RNAi)</span>,
          selector: (row) => row.sig_percent_RNAi,
            ...(isWidth && {  width:"170px"})
        },
        {
          name: <span className="table-header">Cancer Type</span>,
          selector: (row) => row.cancer_type,
            ...(isWidth && {  width:"130px"})
        },
        {
          name: <span className="table-header">Histological Subtype</span>,
          selector: (row) => row.histological_subtype,
             ...(isWidth && { width:"180px"})
        },
      ];

    case "Drug_Sensitivity":
      return [
        {
          name: <span className="table-header">Gene Name</span>,
          selector: (row) => row.geneName,
        },
        {
          name: <span className="table-header">Data Level</span>,
          selector: (row) => row.dataLevel,
        },
        {
          name: <span className="table-header">Drug Category</span>,
          selector: (row) => row.drugCategory,
        },
        {
          name: <span className="table-header">Cancer Type</span>,
          selector: (row) => row.cancer_type,
        },
        {
          name: <span className="table-header">Histological Subtype</span>,
          selector: (row) => row.histological_subtype,
        },
      ];

    case "Significant_Condition":
      return [
        {
          name: <span className="table-header">Genes Type</span>,
          selector: (row) => row.genesType,
           width: "180px",
        },
        {
          name: <span className="table-header">Genes</span>,
          selector: (row) => row.genesList,
          cell: (row) => (
            <div className="network-name-container">
              <span className="">{row.genesList}</span>
            </div>
        ),
          ...(!isWidth && { width: "400px" }),
        },
      ];

    case "Pathway":
      return [
        {
          name: <span className="table-header">Gene Set</span>,
          selector: (row) => row.geneSet,
        },
        {
          name: <span className="table-header">Gene Name</span>,
          selector: (row) => row.geneName,
          width: "150px",
        },
        {
          name: <span className="table-header">Gene Set Link</span>,
          selector: (row) => row.geneSetLink,
          cell: (row) => (
            <div className="network-name-container">
           {row.geneSetLink}
            </div>
        ),
        },
        {
          name: <span className="table-header">MSigDBcollection</span>,
          selector: (row) => row.MSigDBcollection,
        },
      ];
    case "Centrality":
      return getCentralityColumns(centrality);
    default:
      return [];
  }
};

export const getCentralityColumns = (centrality) => {

  const columnArray = [
    {
      name: <span className="table-header">Genes Name </span>,
      selector: (row) => row.geneName,
    },
    {
      name: <span className="table-header">Genes Level</span>,
      selector: (row) => row.geneLevel,
    },
  ];
  switch (centrality) {
    case "degree_centrality":
      columnArray.push(
        {
          name: <span className="table-header"> Degree Centrality </span>,
          selector: (row) => row.degree_centrality,
        },
        {
          name: <span className="table-header">Degree Percentile</span>,
          selector: (row) => row.degree_percentile,
        }
      );
      break;
    case "in_degree_centrality":
      columnArray.push(
        {
          name: <span className="table-header">In Degree Centrality </span>,
          selector: (row) => row.in_degree_centrality,
        },
        {
          name: <span className="table-header">In Degree Percentile </span>,
          selector: (row) => row.in_degree_percentile,
        }
      );
      break;

    case "out_degree_centrality":
      columnArray.push(
        {
          name: <span className="table-header">Out Degree Centrality </span>,
          selector: (row) => row.out_degree_centrality,
        },
        {
          name: <span className="table-header">Out Degree Percentile </span>,
          selector: (row) => row.out_degree_percentile,
        }
      );
      break;

    case "eigenvector_centrality":
      columnArray.push(
        {
          name: <span className="table-header">Eigenvector centrality </span>,
          selector: (row) => row.eigenvector_centrality,
        },
        {
          name: <span className="table-header">Eigenvector Percentile </span>,
          selector: (row) => row.eigenvector_percentile,
        }
      );
      break;
    case "closeness_centrality":
      columnArray.push(
        {
          name: <span className="table-header">Closeness Centrality </span>,
          selector: (row) => row.closeness_centrality,
        },
        {
          name: <span className="table-header">Closeness Percentile </span>,
          selector: (row) => row.closeness_percentile,
        }
      );
      break;
    case "betweenness_centrality":
      columnArray.push(
        {
          name: <span className="table-header">Betweenness Centrality </span>,
          selector: (row) => row.betweenness_centrality,
        },
        {
          name: <span className="table-header"> Betweenness Percentile </span>,
          selector: (row) => row.betweenness_percentile,
        }
      );
      break;
      default:
        columnArray.push(
        {
          name: <span className="table-header"> Voterank Centrality </span>,
          selector: (row) => row.voterank_centrality,
        },
        {
          name: <span className="table-header">Voterank Percentile </span>,
          selector: (row) => row.voterank_percentile,
        }
      );

  }
  return columnArray;
};
